import { Show, createSignal, onMount } from "solid-js";

type MobileOS = 'ios' | 'android' | null;

export function InstallPrompt() {
  const [isVisible, setIsVisible] = createSignal(false);
  const [isClosing, setIsClosing] = createSignal(false);
  const [isHidden, setIsHidden] = createSignal(true);
  const [mobileOS, setMobileOS] = createSignal<MobileOS>(null);

  onMount(() => {
    const userAgent = navigator.userAgent;

    // Check if running on iOS
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

    // Check if running on Android
    const isAndroid = /Android/.test(userAgent);

    // Check if already installed (running in standalone mode)
    const isInstalled = window.matchMedia('(display-mode: standalone)').matches ||
                       (window.navigator as any).standalone === true;

    console.log('PWA Install Prompt - iOS:', isIOS, 'Android:', isAndroid, 'Installed:', isInstalled);

    // Show prompt only on mobile and when not installed
    if ((isIOS || isAndroid) && !isInstalled) {
      setMobileOS(isIOS ? 'ios' : 'android');
      // Delay to let the app load first
      setTimeout(() => {
        setIsHidden(false);
        setTimeout(() => setIsVisible(true), 50);
      }, 1500);
    }
  });

  const handleClose = () => {
    setIsClosing(true);

    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        setIsHidden(true);
        setIsClosing(false);
      }, 50);
    }, 300);
  };

  return (
    <Show when={!isHidden()}>
      <div classList={{ "install-prompt-overlay": true, "closing": isClosing(), "hidden": !isVisible() }}>
        <div classList={{ "install-prompt": true, "closing": isClosing() }}>
          <button class="install-prompt-close" onClick={handleClose}>
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="install-prompt-title">Install HappyTidy</h3>
          <p class="install-prompt-subtitle">Add to your home screen for quick access</p>

          <Show when={mobileOS() === 'ios'}>
            <div class="install-steps">
              <div class="install-step">
                <span class="step-number">1</span>
                <span class="step-text">Tap <i class="fa-solid fa-ellipsis-h step-icon"></i> in Safari</span>
              </div>

              <div class="install-step">
                <span class="step-number">2</span>
                <span class="step-text">Tap "Share" <i class="fa-solid fa-arrow-up-from-bracket step-icon"></i></span>
              </div>

              <div class="install-step">
                <span class="step-number">3</span>
                <span class="step-text">Look for "Add to Home Screen":</span>
              </div>

              <div class="ios-menu">
                <div class="ios-menu-item ios-menu-item--highlight">
                  <i class="fa-solid fa-plus-square"></i>
                  <span>Add to Home Screen</span>
                </div>
              </div>

              <div class="install-step">
                <span class="step-number">4</span>
                <span class="step-text">Tap "Add" to confirm</span>
              </div>
            </div>
          </Show>

          <Show when={mobileOS() === 'android'}>
            <div class="install-steps">
              <div class="install-step">
                <span class="step-number">1</span>
                <span class="step-text">Tap <i class="fa-solid fa-ellipsis-vertical step-icon"></i> menu in Chrome</span>
              </div>

              <div class="install-step">
                <span class="step-number">2</span>
                <span class="step-text">Look for one of these options:</span>
              </div>

              <div class="ios-menu">
                <div class="ios-menu-item ios-menu-item--highlight">
                  <i class="fa-solid fa-plus"></i>
                  <span>Add to Home screen</span>
                </div>
                <div class="ios-menu-item ios-menu-item--highlight">
                  <i class="fa-solid fa-download"></i>
                  <span>Install app</span>
                </div>
              </div>

              <div class="install-step">
                <span class="step-number">3</span>
                <span class="step-text">Tap "Add" or "Install" to confirm</span>
              </div>
            </div>
          </Show>
        </div>
      </div>
    </Show>
  );
}
